import { Box, SvgIcon, Typography } from '@mui/material'
import React from 'react'

export interface ISectionTitleProps {
    icon?: any
    title: string;
}

const SectionTitle: React.FC<ISectionTitleProps> = ({ icon, title }) => {
    return <Box display={"flex"} gap={"17px"}>
        <SvgIcon component={icon} inheritViewBox sx={{ width: "20px", height: "20px" }} style={{}} />
        <Typography fontSize={"18px"} lineHeight={"21.94px"} fontWeight={"500"}>{title}</Typography>
    </Box>
}

export default SectionTitle